/**
 * Prova social — 50 rostos, 3 visíveis, troca 1x/dia (igual em PDP e rodapé).
 */
(function () {
  var FACE_COUNT = 50;
  var COLS = 10;
  var ROWS = 5;

  function saoPauloYmd() {
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo' }).format(new Date());
  }

  function daysSince(epochYmd) {
    var today = saoPauloYmd();
    var start = Date.parse(epochYmd + 'T12:00:00-03:00');
    var now = Date.parse(today + 'T12:00:00-03:00');
    if (Number.isNaN(start) || Number.isNaN(now)) return 0;
    return Math.max(0, Math.round((now - start) / 86400000));
  }

  function spritePosition(index) {
    var col = index % COLS;
    var row = Math.floor(index / COLS);
    var x = col === 0 ? '0%' : ((col / (COLS - 1)) * 100).toFixed(4) + '%';
    var y = row === 0 ? '0%' : ((row / (ROWS - 1)) * 100).toFixed(4) + '%';
    return x + ' ' + y;
  }

  function applyFaces() {
    var blocks = document.querySelectorAll('[data-belabelly-gifted-proof]');
    if (!blocks.length) return;
    var epoch = blocks[0].getAttribute('data-epoch') || '2026-09-14';
    var start = daysSince(epoch) % FACE_COUNT;
    blocks.forEach(function (block) {
      block.querySelectorAll('[data-gifted-face]').forEach(function (el, i) {
        el.style.backgroundPosition = spritePosition((start + i) % FACE_COUNT);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFaces);
  } else {
    applyFaces();
  }
})();
